import styled from 'styled-components';
import { TokenName } from '@mewssystems/design-tokens';
import { Disableable, getTextTokenPreset, getToken } from '@optimus-web/common';

export interface RadioButtonElementProps {
    checked?: boolean;
    disabled?: boolean;
}

export const RadioButtonElement = styled.label<RadioButtonElementProps>`
    display: inline-flex;
    align-items: center;
    padding: ${getToken(TokenName.SPACING_50)}px 0;
    cursor: ${({ disabled }) => (disabled ? 'not-allowed' : 'pointer')};
`;

export interface RadioLabelElementProps extends Disableable {
    htmlFor?: string;
    checked?: boolean;
    small?: boolean;
}

export const RadioLabelElement = styled.span<RadioLabelElementProps>`
    ${({ small }) => (small ? getTextTokenPreset('BODY_M') : getTextTokenPreset('BODY_L'))}
    color: ${(props) => (props.disabled ? getToken(TokenName.TEXT_DISABLED) : getToken(TokenName.TEXT_STATIC_PRIMARY))};
`;
